import { useScrollIntoView } from '@mantine/hooks';
import { useReducedMotion } from 'motion/react';
import { useEffect, useEffectEvent } from 'react';
import { PiXCircleFill } from 'react-icons/pi';
import { FormattedMessage } from 'react-intl';
import { errorCommonI18n } from '@_/i18n-common';

export interface ErrorMessageProps {
  message?: React.ReactNode;
  plain?: boolean;
  scrollOnMount?: boolean;
}

export function ErrorMessage({ message, plain = false, scrollOnMount }: ErrorMessageProps) {
  const shouldReduceMotion = useReducedMotion();
  const scroll = useScrollIntoView({ duration: shouldReduceMotion ? 0 : 200 });

  const scrollIntoView = useEffectEvent(() => {
    if (scrollOnMount) {
      scroll.scrollIntoView();
    }
  });

  useEffect(() => {
    scrollIntoView();
  }, []);

  let msg = message;
  if (typeof message === 'undefined' || message === true) {
    msg = <FormattedMessage {...errorCommonI18n.general} />;
  }

  if (plain) {
    return (
      <div className="text-sm font-medium text-red-600" ref={scroll.targetRef}>
        {msg}
      </div>
    );
  }

  return (
    <div className="rounded-md bg-red-50 p-4" ref={scroll.targetRef}>
      <div className="flex">
        <div className="shrink-0">
          <PiXCircleFill className="size-5 text-red-400" />
        </div>

        <div className="ml-3">
          <div className="text-sm font-medium text-red-700">{msg}</div>
        </div>
      </div>
    </div>
  );
}
